export const PN_TEMPLATE = "PN_TEMPLATE";
export const PN_TEMPLATE_SUCCESS = "PN_TEMPLATE_SUCCESS";
export const PN_TEMPLATE_FAIL = "PN_TEMPLATE_FAIL";

export const CREATE_PN_TEMPLATE = "CREATE_PN_TEMPLATE";
export const CREATE_PN_TEMPLATE_SUCCESS = "CREATE_PN_TEMPLATE_SUCCESS";
export const CREATE_PN_TEMPLATE_FAIL = "CREATE_PN_TEMPLATE_FAIL";

export const UPDATE_PN_TEMPLATE = "UPDATE_PN_TEMPLATE";
export const UPDATE_PN_TEMPLATE_SUCCESS = "UPDATE_PN_TEMPLATE_SUCCESS";
export const UPDATE_PN_TEMPLATE_FAIL = "UPDATE_PN_TEMPLATE_FAIL";

export const REMOVE_PN_TEMPLATE = "REMOVE_PN_TEMPLATE";
export const REMOVE_PN_TEMPLATE_SUCCESS = "REMOVE_PN_TEMPLATE_SUCCESS";
export const REMOVE_PN_TEMPLATE_FAIL = "REMOVE_PN_TEMPLATE_FAIL";
